<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(function () {
    $('.team-block-grid-item').click(function () {
        $(this).children('.team-member-popup').addClass('open')
        $(this).children('.team-member-popup-wrapper').fadeIn(500)
    })
    $('.close-team-popup').click(function () {
        const popup = $(this).closest('.team-block-grid-item');
        popup.find('.team-member-popup-wrapper').fadeOut(500);
        popup.find('.team-member-popup').fadeOut(500);
    })
});
